import { Divider } from 'components/NewCompanyPage/Sidebar/shared'
import { HOTEL_AMENITIES, HotelAmenityFields } from 'constants/hotelAmenities'
import { HotelAmenitiesChips } from './HotelAmenitiesChips'

export function LodgingAmenitiesSection({
  data,
}: {
  data?: HotelAmenityFields | null
}) {
  if (!data) return null
  const hasAny = HOTEL_AMENITIES.some((a) => data[a.key] === true)
  if (!hasAny) return null

  return (
    <>
      <Divider />
      <div className="flex flex-col gap-2 px-2">
        <div className="text-sm font-medium text-fg-secondary">
          Hotel Amenities
        </div>
        <HotelAmenitiesChips data={data} />
      </div>
    </>
  )
}
